var _circle, _circle2, _circle3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoadmapBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 835,
    height: 835,
    viewBox: "0 0 835 835",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 417.547,
    cy: 417.547,
    r: 190.408,
    stroke: "url(#paint0_linear_59_222)",
    strokeOpacity: 0.7
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 417.547,
    cy: 417.547,
    r: 305.423,
    stroke: "url(#paint1_linear_59_222)",
    strokeOpacity: 0.7
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 417.547,
    cy: 417.547,
    r: 416.953,
    stroke: "url(#paint2_linear_59_222)",
    strokeOpacity: 0.7
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_59_222",
    x1: 417.547,
    y1: 226.638,
    x2: 417.547,
    y2: 608.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.266667,
    stopColor: "#040E0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.596667,
    stopColor: "#0AD78D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_59_222",
    x1: 417.547,
    y1: 111.625,
    x2: 417.547,
    y2: 723.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.266667,
    stopColor: "#040E0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.596667,
    stopColor: "#0AD78D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_59_222",
    x1: 417.547,
    y1: 0.09375,
    x2: 417.547,
    y2: 835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.266667,
    stopColor: "#040E0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.596667,
    stopColor: "#0AD78D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadmapBg);
export default __webpack_public_path__ + "static/media/roadmap-bg.86df3bd3009a34a7494c20be5447bcf8.svg";
export { ForwardRef as ReactComponent };